import React from "react";
import PropTypes from "prop-types";

export default class ReadingProgress extends React.Component {
  render() {
    const { size, completed, total, color, borderColor } = this.props;
    const attrs = this.props[size];
    const radius = attrs.radius - attrs.borderWidth / 2;
    const width = attrs.radius * 2;
    const height = attrs.radius * 2;
    const viewBox = `0 0 ${width} ${height}`;
    const dashArray = radius * Math.PI * 2;
    const percentage = completed < total ? (100 * completed) / total : 100;
    const dashOffset = dashArray - (dashArray * percentage) / 100;

    return (
      <svg aria-hidden width={width} height={height} viewBox={viewBox}>
        <circle
          cx={attrs.radius}
          cy={attrs.radius}
          r={radius}
          strokeWidth={`${attrs.borderWidth}px`}
          stroke={borderColor}
          style={{ fill: "none" }}
        />
        <circle
          cx={attrs.radius}
          cy={attrs.radius}
          r={radius}
          strokeWidth={`${attrs.borderWidth}px`}
          stroke={color}
          transform={`rotate(270, ${attrs.radius} ${attrs.radius})`}
          style={{
            fill: "none",
            strokeDasharray: dashArray,
            strokeDashoffset: dashOffset
          }}
        />
        <text
          x={attrs.x}
          y={attrs.y}
          dy=".4em"
          textAnchor="middle"
          fontSize={`${attrs.numberSize}px`}
          style={{
            fill: color
          }}
        >
          {`${completed}/${total}`}
        </text>
        <text
          x={attrs.radius}
          y={attrs.radius}
          dy=".4em"
          textAnchor="middle"
          fontSize={`${attrs.fontSize}px`}
          style={{
            fill: color,
            textTransform: "uppercase"
          }}
        >
          <tspan x={attrs.radius} dy={`${attrs.dy}em`}>
            {i18n.t("assignments.readings")}
          </tspan>
          <tspan x={attrs.radius} dy="1.2em">
            {i18n.t("assignments.complete")}
          </tspan>
        </text>
      </svg>
    );
  }
}

ReadingProgress.propTypes = {
  total: PropTypes.number.isRequired,
  completed: PropTypes.number.isRequired,
  size: PropTypes.string,
  borderColor: PropTypes.string,
  color: PropTypes.string
};

ReadingProgress.defaultProps = {
  size: "normal",
  completed: 0,
  total: 0,
  borderColor: "#ECECEC",
  color: "#684182",
  normal: {
    x: 90,
    y: 70,
    dy: 2,
    radius: 90,
    fontSize: 14,
    numberSize: 55,
    borderWidth: 10
  },
  small: {
    x: 60,
    y: 50,
    dy: 1.8,
    radius: 60,
    fontSize: 10,
    numberSize: 35,
    borderWidth: 10
  }
};
